export default __webpack_public_path__ + "static/media/faq-bg.ecba02fd.jpg";